import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { with: String }

  connect() {
    this.element.dataset['action'] = 'submit->disable-buttons#disableForm';

    // Default message if not set
    if (!this.hasWithValue) {
      this.withValue = "Processing...";
    }
  }

  disableForm() {
    this.submitButtons().forEach(button => {
      button.disabled = true;
      this.showLoadingState(button);
    });
  }

  showLoadingState(button) {
    // Create a spinner element
    const spinner = document.createElement('span');
    spinner.classList.add('spinner-border', 'spinner-border-sm', 'ms-2');
    spinner.setAttribute('role', 'status');
    spinner.setAttribute('aria-hidden', 'true');

    // Clear existing text and append spinner
    button.innerHTML = '';
    button.appendChild(spinner);

    // Set button text
    const text = document.createElement('span');
    text.textContent = this.withValue;
    button.appendChild(text);
  }

  submitButtons() {
    return this.element.querySelectorAll("button[type='submit'], input[type='submit']");
  }
}
